<template>
  <b-dropdown right no-caret>
    <template slot="button-content">
      <img src="static/img/assets/edit.png">
    </template>
    <!-- <b-dropdown-item href="#">編集</b-dropdown-item> -->
    <b-dropdown-item @click="onClickDelete">{{$t('deleteStr')}}</b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  namr: 'CommentDropDown',
  data () {
    return {
    }
  },
  methods: {
    onClickDelete: function () {
      this.$emit('comment-delete')
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Comment/CommentDropDown.vue